import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import { quoteLinkFor, whatsappMessageUrl } from '../utils/contactLinks';
import { getBrandProduct } from '../data/brandProducts';

// Card title for one brand's version of a product: "Siniat" + "Skimming & Jointing Plaster".
// Skips the type when the brand name already says it ("Knauf Insulation").
export function brandProductName(product, brand) {
  const type = product.typeName || product.title;
  if (!brand) return product.title;
  const detail = getBrandProduct(product.id, brand.id);
  if (detail?.name) return detail.name;
  const brandName = brand.shortName || brand.name;
  return brandName.toLowerCase().includes(type.toLowerCase()) ? brandName : `${brandName} ${type}`;
}

// One product from one brand (category pages). Sourced brand-specific details come from
// data/brandProducts.js; anything missing falls back to brands.js / products.js.
function BrandProductCard({ product, brand }) {
  const name = brandProductName(product, brand);
  const detail = brand ? getBrandProduct(product.id, brand.id) : null;
  const description = detail?.description || (brand ? brand.description : product.description);
  const features = detail?.features || product.features;
  const applications = detail?.applications || product.applications;
  const waUrl = whatsappMessageUrl(`Hi OJANNA, I'd like a quote for ${name}.`);

  return (
    <article className="brand-product-card" data-track-location="product_card" id={brand ? `${product.id}-${brand.id}` : `product-${product.id}`}>
      <header className="brand-product-head">
        {brand && (
          <span className="brand-product-logo">
            <img src={brand.logo} alt={`${brand.name} logo`} loading="lazy" />
          </span>
        )}
        <div>
          {brand?.tier === 'master' && <span className="brand-product-type">Master distributor</span>}
          <h3>{name}</h3>
        </div>
      </header>

      <p className="brand-product-desc">{description}</p>

      <div className="brand-product-cols">
        <div>
          <h4>Key features</h4>
          <ul className="brand-product-features">
            {features.map((f) => (
              <li key={f}>
                <span className="feature-check">✓</span>
                {f}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4>Applications</h4>
          <div className="application-tags">
            {applications.map((a) => (
              <span key={a} className="app-tag">
                {a}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="brand-product-actions">
        <Link to={quoteLinkFor(product.categoryId, name)} className="btn btn-primary">
          Get a quote <Icon name="arrow" size={16} />
        </Link>
        <a
          href={waUrl}
          className="btn btn-outline brand-product-wa"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon name="whatsapp" size={18} /> WhatsApp
        </a>
      </div>
    </article>
  );
}

export default BrandProductCard;
